<!-- 分成方新增/编辑 -->
<template>
  <ykc-form class="el-form-wrap">
    <div>
      <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm0" class="el-form-wrap">
        <ykc-form-item label="分成方编号" prop="partnerNo" v-if="isEdit">
          <ykc-input
            placeholder="请输入分成方编号"
            v-model="ruleForm.partnerNo"
            disabled></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="分成方名称" prop="partnerName">
          <ykc-input
            placeholder="请输入分成方名称"
            maxlength="50"
            v-model="ruleForm.partnerName"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="分成方类型" prop="partnerType">
          <ykc-dropdown
            placeholder="请选择分成方类型"
            :data="partnerTypeData"
            v-model="ruleForm.partnerType"></ykc-dropdown>
        </ykc-form-item>
        <ykc-form-item label="结算周期" prop="settlementCycle">
          <ykc-dropdown
            placeholder="请选择结算周期"
            :data="settlementCycleData"
            v-model="ruleForm.settlementCycle"></ykc-dropdown>
        </ykc-form-item>
        <ykc-form-item label="分成方地址" prop="partnerAddress">
          <ykc-input
            placeholder="请输入分成方地址"
            maxlength="100"
            v-model="ruleForm.partnerAddress"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="资质名称" prop="aptitudeName">
          <ykc-input
            placeholder="请输入资质名称"
            maxlength="100"
            v-model="ruleForm.aptitudeName"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="联系人姓名" prop="contacts">
          <ykc-input
            placeholder="请输入联系人姓名"
            maxlength="50"
            v-model="ruleForm.contacts"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="联系人性别" prop="contactsSex">
          <ykc-dropdown
            placeholder="请选择联系人性别"
            :data="contactsSexData"
            v-model="ruleForm.contactsSex"></ykc-dropdown>
        </ykc-form-item>
        <ykc-form-item label="联系人手机号" prop="contactsPhone">
          <ykc-input
            placeholder="请输入联系人手机号"
            maxlength="50"
            v-model="ruleForm.contactsPhone"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="联系人职务" prop="contactsJob">
          <ykc-input
            placeholder="请输入联系人职务"
            maxlength="50"
            v-model="ruleForm.contactsJob"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="联系人邮箱" prop="contactsEmail">
          <ykc-input
            placeholder="请输入联系人邮箱"
            maxlength="50"
            v-model="ruleForm.contactsEmail"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="联系人电话" prop="contactsTelephone">
          <ykc-input
            placeholder="请输入联系人电话"
            maxlength="50"
            v-model="ruleForm.contactsTelephone"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="收款单位名称" prop="company">
          <ykc-input
            placeholder="请输入收款单位名称"
            maxlength="50"
            v-model="ruleForm.company"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="收款银行" prop="bank">
          <ykc-input
            placeholder="请输入收款银行"
            maxlength="50"
            v-model="ruleForm.bank"></ykc-input>
        </ykc-form-item>
        <ykc-form-item label="收款账号" prop="bankNo">
          <ykc-input
            placeholder="请输入收款账号"
            maxlength="50"
            v-model="ruleForm.bankNo"></ykc-input>
        </ykc-form-item>
      </ykc-form>
    </div>
  </ykc-form>
</template>
<script>
  import { partnerData } from '@/service/apis';

  export default {
    props: {
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: Number,
      },
    },
    name: 'PartnerAddOrEdit',
    data() {
      return {
        partnerTypeData: [
          { id: 1, name: '物业集团' },
          { id: 2, name: '外部居间方' },
          { id: 3, name: '代建方' },
          { id: 4, name: '其他' },
        ],
        settlementCycleData: [
          { id: 1, name: '月' },
          { id: 2, name: '季度' },
          { id: 3, name: '半年' },
          { id: 4, name: '年' },
        ],
        contactsSexData: [
          { id: 1, name: '男' },
          { id: 2, name: '女' },
          { id: 3, name: '未知' },
        ],
        ruleForm: {
          id: '',
          partnerNo: '',
          partnerName: '',
          partnerType: '',
          settlementCycle: 1,
          partnerAddress: '',
          aptitudeName: '',
          contacts: '',
          contactsSex: '',
          contactsPhone: '',
          contactsJob: '',
          contactsEmail: '',
          contactsTelephone: '',
          company: '',
          bank: '',
          bankNo: '',
        },
        rules: {
          partnerName: [{ required: true, message: '请输入分成方名称', trigger: 'blur' }],
          partnerType: [{ required: true, message: '请选择分成方类型', trigger: 'change' }],
          settlementCycle: [{ required: true, message: '请选择结算周期', trigger: 'change' }],
          company: [{ required: true, message: '请输入收款单位名称', trigger: 'blur' }],
          bank: [{ required: true, message: '请输入收款银行', trigger: 'blur' }],
          bankNo: [{ required: true, message: '请输入收款账号', trigger: 'blur' }],
        },
      };
    },
    mounted() {
      if (this.id) {
        partnerData
          .partnerDetail({ id: this.id })
          .then(res => {
            this.ruleForm = {
              ...this.ruleForm,
              ...res,
            };
          })
          .catch(() => {});
      }
    },
    computed: {
      formData() {
        const formData = {
          ...this.ruleForm,
          id: this.id,
        };
        return formData;
      },
    },
    methods: {
      submitForm() {
        return new Promise(resolve => {
          this.validateAllForm().then(() => {
            partnerData
              .saveOrUpdate(this.formData)
              .then(() => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                resolve();
              })
              .catch(() => {});
          });
        });
      },
      validateAllForm() {
        return new Promise((resolve, reject) => {
          Promise.all(
            Object.keys(this.$refs)
              .filter(o => o.includes('ruleForm'))
              .map(o => {
                return new Promise((_resolve, _reject) => {
                  this.$refs[o].validate(valid => {
                    if (valid) {
                      _resolve();
                    } else {
                      _reject();
                    }
                  });
                });
              })
          )
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .upload-img-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
